export function isDevelopHost() {
  if (_.isNil(window)) {
    return false;
  }
  const host = window.location.host
    .replace(/:\d+/, '');
  return _.includes([
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'dev.ibleaders.com',
  ], host);
}
